import classNames from 'classnames'
import { useMemo } from 'react'

import type { ReactElement, InputHTMLAttributes, ReactNode } from 'react'

import Label from '~/components/Label'

import './styles.scss'

export interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  className?: string
  isChecked?: boolean
  label?: string
  labelPosition?: 'left' | 'right'
  size?: Exclude<SIZES, 'large'>
  tooltip?: ReactNode
}

const CheckboxInput = ({
  className,
  isChecked,
  label,
  labelPosition = 'right',
  size = 'medium',
  tooltip,
  ...props
}: Props): ReactElement => {
  /** Local state */

  const checkboxContainerClasses = classNames('checkbox-input-component-container', {
    [`${labelPosition}-label`]: labelPosition === 'left' || labelPosition === 'right',
  })

  const checkboxInputClasses = classNames('checkbox-input-component', className, size)

  const labelComponent = useMemo(
    () =>
      label ? (
        <Label
          className={classNames('checkbox-input-component__label', size, { disabled: props.disabled })}
          label={label}
          tooltip={tooltip}
        />
      ) : null,
    [label, props.disabled, size, tooltip]
  )

  /** Render */

  return (
    <div className={checkboxContainerClasses}>
      {labelPosition === 'left' ? labelComponent : null}
      <input checked={isChecked} className={checkboxInputClasses} type="checkbox" {...props} />
      {labelPosition === 'right' ? labelComponent : null}
    </div>
  )
}

export default CheckboxInput
